import { Box } from '@mui/material';
import React from 'react';
import {
  StyledProfileSection,
  StyledSectionContent,
  StyledSectionDescription,
  StyledSectionHeader,
} from '../styles';

type ProfileSectionProps = {
  title: string;
  description?: string;
  children: React.ReactNode;
  withSurface?: boolean;
};

export const ProfileSection: React.FC<ProfileSectionProps> = ({
  title,
  description,
  children,
  withSurface = true,
}) => {
  return (
    <StyledProfileSection>
      <StyledSectionHeader variant='h6'>{title}</StyledSectionHeader>
      {description && (
        <StyledSectionDescription variant='body2'>
          {description}
        </StyledSectionDescription>
      )}
      {withSurface ? (
        <StyledSectionContent>{children}</StyledSectionContent>
      ) : (
        <Box>{children}</Box>
      )}
    </StyledProfileSection>
  );
};
